import { LOGO_URL } from "@/lib/constants";

export const Logo = ({ className = "h-9", withText = false }) => {
  return (
    <div className="flex items-center gap-3" data-testid="mu-logo">
      <img src={LOGO_URL} alt="Mahindra University" className={className} />
      {withText && (
        <div className="hidden sm:block">
          <div className="text-xs tracking-[0.15em] uppercase text-[#9CA3AF] font-semibold">
            Admissions 2026
          </div>
          <div className="text-sm font-semibold text-[#111111]">
            Registration Portal
          </div>
        </div>
      )}
    </div>
  );
};
